import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { keyBy, merge } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { LanControllerInfo } from "../GQLCalls/getLanControllersCall";

type CpuOptions = {lanControllerId: number, cpuId: string}

export type LanControllerItem = DynamicDataObk<LanControllerInfo[]> & { cpuOptions?: CpuOptions[] }

const lanControllerDataAdapter = createEntityAdapter({
  selectId: (item: LanControllerItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<LanControllerItem, string>, {con, data, cpuOptions}: LanControllerItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const dataDictionary = keyBy(state.entities[identifier].data, "lanControllerId")
    data.forEach((entry) => dataDictionary[entry.controller_id] = entry)
    const newPayload = {con, data: Object.values(dataDictionary), cpuOptions: Object.values(merge({}, keyBy(state.entities[identifier].cpuOptions, "lanControllerId"), keyBy(cpuOptions, "lanControllerId")))}
    lanControllerDataAdapter.upsertOne(state, newPayload);
  } else { lanControllerDataAdapter.addOne(state, {con, data, cpuOptions: cpuOptions ?? [] })}
}

const lanControllerSlice = createSlice({
  name: "lanControllers",
  initialState: lanControllerDataAdapter.getInitialState(),
  reducers: {
    maintained: (state, {payload}:PayloadAction<LanControllerItem>) => {
      mergePayloadAndState(state, payload);
    }
  }
})

export const LanControllerActions = lanControllerSlice.actions;
export default lanControllerSlice.reducer;